// Carrousel Instagram (6 visuels 1080 × 1080) aux couleurs de la charte 360immoinvest, généré dans le navigateur.
const C = { graphite: "#121311", ivoire: "#f6f2ea", laiton: "#b8925a", laitonFonce: "#8c6b3e", accentText: "#7d5f33", muted: "#5e5a53", mutedDark: "#a8a398", hairline: "#d9d2c4", hairlineDark: "#34352f", sauge: "#3e5245" };
const S = 1080, M = 96;
const eur = (n) => `${Math.round(Number(n) || 0).toLocaleString("fr-FR").replace(/\u202f|\u00a0/g, " ")} €`;
const SERIF = "Fraunces, Georgia, serif", SANS = "Inter, system-ui, sans-serif";

const loadImg = (src) => new Promise((ok) => { const i = new Image(); i.onload = () => ok(i); i.onerror = () => ok(null); i.src = src; });

function wrap(ctx, text, x, y, maxW, lh) {
  const words = text.split(" ");
  let line = "";
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y); y += lh; line = w; } else line = t;
  }
  if (line) ctx.fillText(line, x, y);
  return y + lh;
}

function base(ctx, dark, page, logos) {
  ctx.fillStyle = dark ? C.graphite : C.ivoire;
  ctx.fillRect(0, 0, S, S);
  const logo = dark ? logos.sombre : logos.clair;
  if (logo) ctx.drawImage(logo, M, M - 10, 230, 230 * (logo.height / logo.width));
  ctx.font = `500 24px ${SANS}`;
  ctx.fillStyle = dark ? C.mutedDark : C.muted;
  ctx.textAlign = "right";
  ctx.fillText(`${page}/${ctx.canvas._total || 6}`, S - M, M + 22);
  ctx.textAlign = "left";
}

function footer(ctx, dark, text = "Information générale : vérifiez votre situation avec votre conseil.") {
  ctx.strokeStyle = dark ? C.hairlineDark : C.hairline;
  ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(M, S - M - 46); ctx.lineTo(S - M, S - M - 46); ctx.stroke();
  ctx.font = `500 22px ${SANS}`;
  ctx.fillStyle = dark ? C.mutedDark : C.muted;
  ctx.fillText(text, M, S - M);
}

function title(ctx, dark, text, y, size = 64) {
  ctx.font = `500 ${size}px ${SERIF}`;
  ctx.fillStyle = dark ? C.ivoire : C.graphite;
  return wrap(ctx, text, M, y, S - 2 * M, size * 1.12);
}

function bigFigure(ctx, text, y, size = 150) {
  ctx.font = `400 ${size}px ${SERIF}`;
  ctx.fillStyle = C.laiton;
  let s = size;
  while (ctx.measureText(text).width > S - 2 * M && s > 70) { s -= 6; ctx.font = `400 ${s}px ${SERIF}`; }
  ctx.fillText(text, M, y);
}

function body(ctx, dark, text, y, size = 34) {
  ctx.font = `400 ${size}px ${SANS}`;
  ctx.fillStyle = dark ? C.mutedDark : C.muted;
  return wrap(ctx, text, M, y, S - 2 * M, size * 1.5);
}

function rows(ctx, list, y) {
  for (const [k, v, strong] of list) {
    ctx.font = `400 32px ${SANS}`; ctx.fillStyle = C.muted; ctx.fillText(k, M, y);
    ctx.font = `${strong ? 600 : 500} 36px ${SANS}`; ctx.fillStyle = strong ? C.accentText : C.graphite;
    ctx.textAlign = "right"; ctx.fillText(v, S - M, y); ctx.textAlign = "left";
    ctx.strokeStyle = C.hairline; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(M, y + 30); ctx.lineTo(S - M, y + 30); ctx.stroke();
    y += 92;
  }
  return y;
}

const SLIDES = [
  (ctx, d, L) => { base(ctx, true, 1, L); let y = title(ctx, true, "LMNP 2027 : ce que le projet de loi pourrait vous coûter", 330, 66); bigFigure(ctx, d.extraYear > 0.5 ? `+ ${eur(d.extraYear)}` : "0 €", y + 140); body(ctx, true, "d'impôt en plus chaque année, d'après notre simulation.", y + 230); footer(ctx, true, "Faites défiler →"); },
  (ctx, d, L) => { base(ctx, false, 2, L); const y = title(ctx, false, "le cas simulé", 300); rows(ctx, [["Régime", d.typeLabel], ["Loyers annuels", eur(d.rents)], ["Valeur du bâti", eur(d.building)], ["Tranche d'imposition", `${d.tmi} %`]], y + 70); footer(ctx, false); },
  (ctx, d, L) => { base(ctx, true, 3, L); const y = title(ctx, true, `sur ${d.horizon} ans, l'addition grimpe`, 330); bigFigure(ctx, `+ ${eur(Math.max(0, d.extra10y))}`, y + 160); body(ctx, true, `d'impôt cumulé entre ${d.firstYear} et ${d.firstYear + d.horizon - 1}, à revenus constants.`, y + 250); footer(ctx, true); },
  (ctx, d, L) => { base(ctx, false, 4, L); const y = title(ctx, false, "aujourd'hui → avec le projet", 300); rows(ctx, [["Résultat imposable aujourd'hui", eur(d.taxableNow)], ["Résultat imposable avec le projet", eur(d.taxableProj), true], ["Impôt aujourd'hui", eur(d.taxNow)], ["Impôt avec le projet", eur(d.taxProj), true]], y + 70); footer(ctx, false); },
  (ctx, d, L) => { base(ctx, false, 5, L); let y = title(ctx, false, "ce qui change : l'amortissement plafonné", 300); ctx.font = `400 120px ${SERIF}`; ctx.fillStyle = C.accentText; ctx.fillText(eur(d.lostAmort), M, y + 120); y = body(ctx, false, `d'amortissement perdu chaque année. Plafond retenu : ${String(d.rate).replace(".", ",")} % du bâti, ${eur(d.cap)} par an et par foyer.`, y + 210); footer(ctx, false); },
  (ctx, d, L) => { base(ctx, true, 6, L); const y = title(ctx, true, "et vous, combien ?", 330, 72); body(ctx, true, "Simulez votre cas en 1 minute, gratuitement et sans inscription :", y + 30); ctx.font = `500 40px ${SANS}`; ctx.fillStyle = C.laiton; ctx.fillText("360immoinvest.com/simulateur-lmnp-2027", M, y + 190); body(ctx, true, "Enregistrez ce post pour le retrouver au moment du vote.", y + 290, 30); footer(ctx, true, "360immoinvest — votre patrimoine locatif, géré à 360°."); },
];

export async function renderLmnpCarousel(data) {
  return renderCarousel(SLIDES, data);
}

export function bullets(ctx, dark, items, y, size = 34) {
  for (const it of items) {
    ctx.font = `500 ${size}px ${SANS}`; ctx.fillStyle = C.laiton; ctx.fillText("→", M, y);
    ctx.font = `400 ${size}px ${SANS}`; ctx.fillStyle = dark ? C.ivoire : C.graphite;
    y = wrapAt(ctx, it, M + 56, y, S - 2 * M - 56, size * 1.45) + 18;
  }
  return y;
}

function wrapAt(ctx, text, x, y, maxW, lh) {
  const words = text.split(" ");
  let line = "";
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y); y += lh; line = w; } else line = t;
  }
  if (line) ctx.fillText(line, x, y);
  return y + lh;
}

export { base, footer, title, bigFigure, body, rows, eur, C, M, S, SANS };

export async function renderCarousel(slides, data) {
  await Promise.all([document.fonts?.load(`500 64px Fraunces`), document.fonts?.load(`400 120px Fraunces`), document.fonts?.load(`500 32px Inter`), document.fonts?.load(`600 32px Inter`)].map((p) => p?.catch?.(() => {})));
  const logos = { clair: await loadImg("/brand/360immoinvest-logo-horizontal-clair.png"), sombre: await loadImg("/brand/360immoinvest-logo-horizontal-sombre.png") };
  return slides.map((draw) => {
    const cv = document.createElement("canvas");
    cv.width = S; cv.height = S; cv._total = slides.length;
    draw(cv.getContext("2d"), data, logos);
    return cv.toDataURL("image/png");
  });
}

export async function downloadZip(urls, prefix = "360immoinvest-lmnp-2027", zipName = "carrousel-lmnp-2027.zip") {
  const { default: JSZip } = await import("jszip");
  const zip = new JSZip();
  urls.forEach((u, i) => zip.file(`${prefix}-${i + 1}.png`, u.split(",")[1], { base64: true }));
  const blob = await zip.generateAsync({ type: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = zipName; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
